import api from '@/utils/api'

export default {
    // the requests of the current season, newest first
    getMatchChanges() {
        return api.get('match-changes')
    },

    getMatchChange(id) {
        return api.get(`match-changes/${id}`)
    },

    // the matches the slot of the match can be swapped with
    getCandidates(matchId) {
        return api.get(`match-changes/candidates/${matchId}`)
    },

    // a captain asks to swap the slot of a match of the team with another match: the other captains vote
    requestMatchChange(data) {
        return api.post('match-changes', data)
    },

    vote(id, data) {
        return api.post(`match-changes/${id}/votes`, data)
    },

    // the captain of the requesting team withdraws an open request (it stays in the history as cancelled)
    cancel(id, data) {
        return api.post(`match-changes/${id}/cancel`, data)
    }
}
